module.exports = __webpack_public_path__ + "img/banner-princiapal.e88be77c.svg";